import { useEffect, useRef } from "react";
import NotificationView, { NotificationProps as _NotificationProps } from "./notification-view";
import {useNotificationContext} from "../notifications-outlet/notifications-context";

export type NotificationProps = _NotificationProps;

const AUTO_CLOSE_TIMEOUT = 5000;

export default function Notification(props: NotificationProps) {
  const timeoutRef = useRef<NodeJS.Timeout | undefined>();
  const onClose = props.onClose;
  const autoclose = props.autoClose;
  const {target} = useNotificationContext();
  useEffect(() => {
    if (autoclose && onClose) {
      timeoutRef.current = setTimeout(onClose, AUTO_CLOSE_TIMEOUT);
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }
  }, [onClose, autoclose]);
  return <NotificationView {...props} target={target} />;
}
